import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { ChevronLeft } from "lucide-react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
            toast.success("Password reset request sent");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to submit request");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
            <div className="tf-card-accent w-full max-w-md p-8 border border-[#27272A] relative">
                <Link to="/login" className="absolute top-4 left-4 text-[#52525B] hover:text-[#FAFAFA] text-xs font-mono flex items-center gap-1">
                    <ChevronLeft className="w-3.5 h-3.5" /> BACK
                </Link>
                
                <div className="text-center mt-4 mb-6">
                    <div className="label-mono text-[#00FF41] mb-2">// password recovery</div>
                    <h2 className="heading-md">FORGOT PASSWORD</h2>
                </div>

                {done ? (
                    <div className="space-y-4 text-center">
                        <p className="text-sm text-[#A1A1AA] font-mono leading-relaxed">
                            If the email <span className="text-[#00FF41]">{email}</span> exists in our system, we have generated a temporary password reset link.
                        </p>
                        <p className="text-xs text-[#52525B] font-mono">
                            Please check your server logs (FastAPI backend terminal) for the simulated link link!
                        </p>
                        <Link to="/login" className="tf-btn w-full justify-center mt-6">
                            BACK TO LOGIN
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <div className="label-mono mb-1">EMAIL ADDRESS</div>
                            <div className="flex items-center border-b-2 border-[#27272A] focus-within:border-[#00FF41]">
                                <span className="text-[#52525B] mr-2">{">"}</span>
                                <input 
                                    type="email"
                                    required
                                    className="bg-transparent flex-1 py-2 outline-none font-mono text-[#FAFAFA]" 
                                    placeholder="your@email.com" 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)} 
                                />
                            </div>
                        </div>
                        <button type="submit" disabled={loading} className="tf-btn w-full justify-center">
                            {loading ? "SENDING LINK..." : "GENERATE RESET LINK"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
